import { ReactNode } from "react";
import { SearchIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SuperLink as Link } from "@/components/common/super-link";
import { trans } from "@/service/i18n/i18n";
import { InfoWithCta } from "./info-with-cta";

export const EmptyInfoWithCta = ({
  link,
  title = trans("search_results_for_empty"),
  icon = <SearchIcon size={"24px"} />,
  desc,
}: {
  link: string;
  title?: string;
  icon?: ReactNode;
  desc?: string;
}) => {
  return (
    <div className={"my-16 flex items-center justify-center md:my-24"}>
      <InfoWithCta
        icon={icon}
        title={title}
        cta={
          <Button variant={"blue"} asChild={true}>
            <Link href={link}>{trans("back_to_main_page")}</Link>
          </Button>
        }
        desc={desc}
      />
    </div>
  );
};
